import { render, staticRenderFns } from "./AdCollapsableInfo.vue?vue&type=template&id=6a017a3c&scoped=true"
import script from "./AdCollapsableInfo.vue?vue&type=script&lang=js"
export * from "./AdCollapsableInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a017a3c",
  null
  
)

export default component.exports